// /**
//  * Author: ligj@mapbar.com
//  * Create Time: 2018/01/10 17:09
//  * Description:
//  */



// import Home from './views/Home'
// import Login from './views/login/Login'
// import Index from './views/index/index'
// import serviceCounter from "./views/index/serviceCounter.vue"


// import echartsEG from './views/echartsEG/echarts-eg'

// //统计报表
// import reportsList from './views/statisticalReports/reportsList'
// import reportDetailed from './views/statisticalReports/reportDetailed/reportDetailedList'
// import personStatistics from './views/statisticalReports/personStatis/personStatis'
// import workSheetDetail from './views/statisticalReports/personStatis/workSheetDetail'

// //统计报表 变更细化
// import changeStatusList from './views/statisticalReports/reportRefining/changeRefining/changeStatusList'
// import changeStatusStatis from './views/statisticalReports/reportRefining/changeRefining/changeStatusStatis'
// import groupeChangeStatus from './views/statisticalReports/reportRefining/changeRefining/groupeChangeStatus'
// import changeRFCNum from './views/statisticalReports/reportRefining/changeRefining/changeRFCNum'
// import changeRFCNumStatus from './views/statisticalReports/reportRefining/changeRefining/changeRFCNumStatus'
// import changeRFCNumGroupe from './views/statisticalReports/reportRefining/changeRefining/changeRFCNumGroupe'
// import changeRFCCloseNum from './views/statisticalReports/reportRefining/changeRefining/changeRFCCloseNum'
// import changeRFCCloseNumStatus from './views/statisticalReports/reportRefining/changeRefining/changeRFCCloseNumStatus'
// import changeRFCCloseNumGroupe from './views/statisticalReports/reportRefining/changeRefining/changeRFCCloseNumGroupe'

// //统计报表 细化发布
// import publishStatusList from './views/statisticalReports/reportRefining/publishRefining/publishStatusList'
// import publishStatusStatis from './views/statisticalReports/reportRefining/publishRefining/publishStatusStatis'
// import groupePublishStatus from './views/statisticalReports/reportRefining/publishRefining/groupePublishStatus'
// import publishRFCNum from './views/statisticalReports/reportRefining/publishRefining/publishRFCNum'
// import publishRFCNumStatus from './views/statisticalReports/reportRefining/publishRefining/publishRFCNumStatus'
// import publishRFCNumGroupe from './views/statisticalReports/reportRefining/publishRefining/publishRFCNumGroupe'
// import publishRFCCloseNum from './views/statisticalReports/reportRefining/publishRefining/publishRFCCloseNum'
// import publishRFCCloseNumStatus from './views/statisticalReports/reportRefining/publishRefining/publishRFCCloseNumStatus'
// import publishRFCCloseNumGroupe from './views/statisticalReports/reportRefining/publishRefining/publishRFCCloseNumGroupe'

// //特殊统计
// import mannerAndComplane from './views/statisticalReports/report/specialStatis/mannerAndComplane'
// import serviceDesk from './views/statisticalReports/report/specialStatis/serviceDesk'
// import knowledgeOne from './views/statisticalReports/report/specialStatis/knowledgeOne'
// import knowledgeTwo from './views/statisticalReports/report/specialStatis/knowledgeTwo'
// import saleMoney from './views/statisticalReports/report/specialStatis/saleMoney'
// import serviceLevel from './views/statisticalReports/report/specialStatis/serviceLevel'
// import eventManageBar from './views/statisticalReports/report/specialStatis/eventManageBar'
// import accidentStaticPie from './views/statisticalReports/report/specialStatis/accidentStaticPie'
// import configManagePie from './views/statisticalReports/report/specialStatis/configManagePie'
// import questionManageBar from './views/statisticalReports/report/specialStatis/questionManageBar'
// import changeManageBar from './views/statisticalReports/report/specialStatis/changeManageBar'
// import publishManageBar from './views/statisticalReports/report/specialStatis/publishManageBar'
// //服务台统计
// import personnelEventStatis from './views/statisticalReports/report/serviceStatis/personnelEventStatis'
// import greatEventStatis from './views/statisticalReports/report/serviceStatis/greatEventStatis'
// import eventCloseStatis from './views/statisticalReports/report/serviceStatis/eventCloseStatis'
// import eventFinishedStatis from './views/statisticalReports/report/serviceStatis/eventFinishedStatis'
// import eventOriginStatais from './views/statisticalReports/report/serviceStatis/eventOriginStatais'
// import efficientAndRespond from './views/statisticalReports/report/serviceStatis/efficientAndRespond'
// //变更统计
// import changeEventStatis from './views/statisticalReports/report/changeStatis/changeEventStatis'
// import changeResultStatis from './views/statisticalReports/report/changeStatis/changeResultStatis'
// //发布统计
// import publishEventStatis from './views/statisticalReports/report/publishStatis/publishEventStatis'
// import publishResultStatis from './views/statisticalReports/report/publishStatis/publishResultStatis'
// //CAB统计
// import CABChangeStatis from './views/statisticalReports/report/CABStatis/CABChangeStatis'
// import CABResultStatis from './views/statisticalReports/report/CABStatis/CABResultStatis'
// //配置项统计
// import configChangeStatis from './views/statisticalReports/report/configStatis/configChangeStatis'

// //一线事件管理报表
// import acceptEvents from './views/statisticalReports/firstLineEvent/reports/acceptEvents'
// import satisfactionRate from './views/statisticalReports/firstLineEvent/reports/satisfactionRate'
// import exceedSLA from './views/statisticalReports/firstLineEvent/reports/exceedSLA'

// //事件经理报表
// import eventToPro from './views/statisticalReports/eventManage/reports/eventToPro'
// import bigEventManage from './views/statisticalReports/eventManage/reports/bigEventManage'
// import collectAndBypass from './views/statisticalReports/eventManage/reports/collectAndBypass'

// //问题经理报表
// import commitedPro from './views/statisticalReports/problemManage/reports/commitedPro'
// import proManageHandler from './views/statisticalReports/problemManage/reports/proManageHandler'
// import problemToChange from './views/statisticalReports/problemManage/reports/problemToChange'
// import proToChaNproToClose from './views/statisticalReports/problemManage/reports/proToChaNproToClose'


// //服务台统计报表
// import greatEventList from './views/statisticalReports/serviceList/reports/greatEventList'
// import closeEvent from './views/statisticalReports/serviceList/reports/closeEvent'
// import eventType from './views/statisticalReports/serviceList/reports/eventType'
// import acceptComplete from './views/statisticalReports/serviceList/reports/acceptComplete'
// import eventComplete from './views/statisticalReports/serviceList/reports/eventComplete'
// import eventOutTime from './views/statisticalReports/serviceList/reports/eventOutTime'
// import undistributedWork from './views/statisticalReports/serviceList/reports/undistributedWork'
// import workEfficiency from './views/statisticalReports/serviceList/reports/workEfficiency'

// //报表细化
// //事件细化统计
// import classifyStatistics from './views/statisticalReports/reportDetailed/eventReportDetailed/classifyStatistics'
// import eventCloseClassify from './views/statisticalReports/reportDetailed/eventReportDetailed/eventCloseClassify'
// import eventCloseClassifyGroup from './views/statisticalReports/reportDetailed/eventReportDetailed/eventCloseClassifyGroup'

// //问题细化统计
// import problemStatus from './views/statisticalReports/reportDetailed/proReportDetailed/problemStaus'
// import proStatusUser from './views/statisticalReports/reportDetailed/proReportDetailed/proStatusUser'
// import proStatusUserGroup from './views/statisticalReports/reportDetailed/proReportDetailed/proStatusUserGroup'
// // 故障管理
// import fault from './views/fault/table/index'

// //投诉管理
// import myComplaints from './views/complaintsManage/myComplaints'
// import addMyComplaints from './views/complaintsManage/addMyComplaints'
// import allComplaints from './views/complaintsManage/allComplaints'

// //分类管理
// import classifyKnowledge from './views/classify/knowledge/index';
// import changeKnowledgeMes from './views/classify/knowledge/changeMes.vue';
// import classifyQuestion from './views/classify/question/index';
// import changeQuestionMes from './views/classify/question/changeMes.vue';
// import classifyRequest from './views/classify/request/index';
// import changeRequestMes from './views/classify/request/changeMes.vue';
// import classifyConfigurate from './views/classify/configurate/index';
// import changeConfigurateMes from './views/classify/configurate/changeMes.vue';
// import classifyPublish from './views/classify/publish/index';
// import changePublishMes from './views/classify/publish/changeMes.vue';
// import classifyChange from './views/classify/change/index';
// import changeChangeMes from './views/classify/change/changeMes.vue';

// // 配置项管理
// import UpdataConfiguration from './views/configuration/updata'
// import ConfigurationList from './views/configuration/list'
// import MyConfiguration from './views/configuration/my'
// import ConfigurationDetail from './views/configuration/detail'
// import EventUptata from './views/configuration/eventupdata.vue'
// import RequeryUserList from './views/configuration/requeryUserList.vue'
// import topologicalGraph from "./views/configuration/topologicalGraph.vue"

// import showPologicalDetail from "./views/configuration/showPologicalDetail.vue"
// import showAppDetail from "./views/configuration/showAppDetail.vue"

// // 事件管理
// import eventManage from "./views/eventManage/eventManage.vue";
// import myEventManage from "./views/eventManage/myEventManage.vue"
// import toMeEventManage from "./views/eventManage/toMeEventManage.vue";
// import toMyGroupEventManage from "./views/eventManage/toMyGroupEventManage.vue"
// import eventAdd from "./views/eventManage/eventAdd.vue";
// import eventDetail from "./views/eventManage/eventDetail.vue";
// import ProcessingComplete from "./views/eventManage/ProcessingComplete.vue"


// //文档管理
// import documentList from './views/documentManage/documentList.vue';
// import documentDirectory from './views/documentManage/documentDirectory.vue';
// import changeDirMes from './views/documentManage/changeDirMes.vue';
// import changeListMes from './views/documentManage/changeListMes.vue';
// import documentDetail from './views/documentManage/documentDetail.vue';

// //知识管理
// import knowledgeList from './views/knowledgeManage/knowledgeList.vue';
// import searchKnowledge from './views/knowledgeManage/searchKnowledge.vue';
// import historyKnowledge from './views/knowledgeManage/historyKnowledge.vue';
// import knowledgeDetail from './views/knowledgeManage/detail.vue';
// import addKnowledge from './views/knowledgeManage/addKnowledge.vue';
// import changeStatus from './views/knowledgeManage/changeStatus.vue';
// // 关联页面
// import relevancyEvent from "./views/common/addEvent.vue";
// import relevancyConfig from "./views/common/addConfig.vue";
// import relevancyApp from "./views/common/addApp.vue";
// import relevancyService from "./views/common/addService.vue";
// import relevancyChange from "./views/common/addChange.vue";
// import relevancyDeploy from "./views/common/addDeploy.vue";
// import relevancyProblem from "./views/common/addProblem.vue";
// import relevancyFault from "./views/common/addFault.vue";
// import relevancySla from "./views/common/addSla.vue";

// // 通用页面
// import department from "./views/common/department.vue"
// import requesterList from "./views/common/requesterList.vue";
// import appoint from "./views/common/appoint.vue";
// import clientVisit from "./views/common/clientVisit.vue";
// import handleComment from "./views/common/handleComment.vue";
// import appointUser from "./views/common/appointUser.vue";
// import setHour from "./views/common/setHour.vue"
// import changeAppoint from "./views/common/changeAppoint.vue";
// import deployAppoint from "./views/common/deployAppoint.vue";
// import flowChart from "./views/common/flowChart.vue"
// import busyness from "./views/common/busyness.vue"
// import redirect from './views/common/redirect'



// // 问题管理
// import problemManage from "./views/problemManage/problemManage.vue"
// import myProblemManage from "./views/problemManage/myProblemManage.vue";
// import toMeProblem from "./views/problemManage/toMeProblem.vue"
// import toMyGroupProblem from "./views/problemManage/toMyGroupProblem.vue"
// import problemAdd from "./views/problemManage/problemAdd.vue";
// import problemDetail from "./views/problemManage/problemDetail.vue";
// import proAssessComplete from "./views/problemManage/assessComplete.vue"
// import proInquiryComplete from "./views/problemManage/inquiryComplete.vue"
// import proRemark from "./views/problemManage/remark.vue"

// // 服务管理
// import ServeCatalog from "./views/serve/catalog/index";
// import ServeCatalogUpdata from "./views/serve/catalog/updata";
// import ClientBargain from "./views/serve/bargain/index";
// import ClientBargainUpdata from "./views/serve/bargain/updata";
// import ClientBargainDetail from "./views/serve/bargain/detail";
// import serviCelevel from "./views/serve/celevel/index";
// import serviCelevelUpdata from "./views/serve/celevel/updata";
// import serviCelevelDetail from "./views/serve/celevel/detail";
// import ServeTeam from "./views/serve/team/index";
// import ServeUser from "./views/serve/team/userinfo";

// //变更管理
// import changeManage from "./views/change/changeManage.vue";
// import myChangeManage from "./views/change/myChangeManage.vue";
// import toMeChangeManage from "./views/change/toMeChangeManage.vue";
// import toMyGroupChangeManage from "./views/change/toMyGroupChangeManage.vue";
// import changeAdd from "./views/change/changeAdd.vue";
// import changeDetail from "./views/change/changeDetail.vue";
// import reporterList from "./views/change/reporterList.vue";
// //发布管理
// import deployManage from "./views/deploy/deployManage.vue";
// import myDeployManage from "./views/deploy/myDeployManage.vue";
// import toMeDeployManage from "./views/deploy/toMeDeployManage.vue";
// import toMyGroupDeployManage from "./views/deploy/toMyGroupDeployManage.vue";
// import deployAdd from "./views/deploy/deployAdd.vue";
// import deployDetail from "./views/deploy/deployDetail.vue";
// import applicantList from "./views/deploy/applicantList.vue";

// // 人员组织关系
// import systemPerson from "./views/system/person.vue";
// import systemUser from "./views/system/user.vue";
// import systemPersonUpdata from "./views/system/personupdata.vue";
// import systemUserAdd from "./views/system/systemUserAdd.vue";

// //巡检管理
// import inspectionManage from './views/inspection/inspectionManage'
// import inspectionCalendar from './views/inspection/inspectionCalendar'
// import inspectionRecord from './views/inspection/inspectionRecord'
// import inspectionAdd from  './views/inspection/inspectionAdd'
// import inspectionAgency from  './views/inspection/inspectionAgency'
// import inspectionTable from  './views/inspection/inspectionTable'


// import addConfiguration from './components/addConfiguration/index'


// //排班管理
// import flightManagement from "./views/workforceManagement/flightManagement.vue";
// import schedulingCalendar from "./views/workforceManagement/schedulingCalendar.vue";
// import schedulingList from "./views/workforceManagement/schedulingList.vue";
// import addScheduling from "./views/workforceManagement/addScheduling.vue";
// import changeScheduling from "./views/workforceManagement/changeScheduling.vue";
// import addSchedulingList from "./views/workforceManagement/addSchedulingList.vue";

// import qrCode from './views/qrCode.vue';

// // 系统管理
// import userManagement from "./views/SystemManagement/userManagement.vue";
// import roleManagement from "./views/SystemManagement/roleManagement.vue"
// import iconManage from "./views/SystemManagement/iconManage.vue"
// import userAdd from "./views/SystemManagement/userAdd.vue"
// import roleAdd from "./views/SystemManagement/roleAdd.vue"

// import iconAdd from "./views/SystemManagement/iconAdd.vue"
// import thirdPartyUserList from './views/SystemManagement/thirdPartyUserList'
// import thirdPartyUserAdd from './views/SystemManagement/thirdPartyUserAdd'

// import onlineUsersList from './views/SystemManagement/onlineUsersList'
// import onlineUsersView from './views/SystemManagement/onlineUsersView'
// // import demo from "./views/demo/demo.vue"

// //应用管理
// import AppcenterManage from './views/appcenter/AppcenterManage' // 应用列表
// import myAppcenterManage from './views/appcenter/myAppcenterManage' // 我的应用
// import AuditApp from './views/appcenter/auditApp' // 我的应用
// import unLoad from './views/cicd/tree/unload'

// // 服务器管理
// import ServerManage from './views/server/serverManage' // 服务器列表
// import serverAdd from './views/server/serverAdd' // 新增服务器

// // 数据字典
// import DictionaryMessage from './views/dictionary/dictionaryMessage' // salt资源管理详情
// import DictionaryAdd from './views/dictionary/dictionaryAdd' // salt资源管理详情

// // 持续集成
// import Tree from './views/cicd/tree/index' // 应用树
// import UseAdd from './views/cicd/tree/useAdd' // 新增应用
// import MenuAdd from './views/cicd/tree/menuAdd' // 新增目录
// import ParamsAdd from './views/cicd/tree/paramsAdd' // 新增参数
// import ParamsMessage from './views/cicd/tree/paramsMessage' // 参数列表
// import UseDetail from './views/cicd/tree/views/detailForm'
// import MenuDetail from './views/cicd/tree/views/menuDetail'
// import ServerList from './views/cicd/tree/views/ServerList'

// import Integration from './views/cicd/tree/views/integration'
// import IntegrationHome from './views/cicd/tree/views/integrationHome'
// import BuildDetail from './views/cicd/tree/views/buildDetail'
// import BuildLog from './views/cicd/tree/views/buildLog'
// import ParamsBuild from './views/cicd/tree/views/paramsBuild'
// import PrevBuild from './views/cicd/tree/views/prevBuild'
// import RollBack from './views/cicd/tree/views/rollBack'


// import DeployAll from './views/cicd/deployAll' // 发布历史
// import DeployMy from './views/cicd/deployMy' // 我的发布
// import MyApproval from './views/cicd/myApproval' // 我的审批
// import Approval from './views/cicd/approval' // 我的审批
// import DeployNew from './views/cicd/deployNew' // 新增发布
// import DeployLine from './views/cicd/deployLine' // 发布上线
           

// export default [
//     {
//         path: '/login',
//         name: 'login',
//         component: Login
//     },
//     {
//         path:"/itsm/qr_code",
//         name:'qrCode',
//         component:qrCode,
//     },
//     {
//         path: '/',
//         component: Home,
//         children: [
//             {
//                 path:"/index",
//                 name:'index',
//                 component:Index,
//                 meta:{ title:"首页" , closable:false}
//             },
//             {
//                 path:"/serviceCounter",
//                 name:'serviceCounter',
//                 component:serviceCounter,
//                 meta:{ title:"服务台" }
//             },
//             {
//                 path:"/echartsEG",
//                 name:'echartsEG',
//                 component:echartsEG,
//                 meta:{ title:"echarts练习" }
//             },
//             {
//                 path:"/reportsList",
//                 name:'reportsList',
//                 component:reportsList,
//                 meta:{ title:"统计报表" }
//             },
//             {
//                 path:"/reportDetailed",
//                 name:'reportDetailed',
//                 component:reportDetailed,
//                 meta:{ title:"报表细化" }
//             },
			// {
            //     path:"/personStatistics",
            //     name:'personStatistics',
            //     component:personStatistics,
            //     meta:{ title:"人员统计" }
            // },
            // {
            //     path:"/workSheetDetail",
            //     name:'workSheetDetail',
            //     component:workSheetDetail,
            //     meta:{
            //         title:"当月详情",
            //         isModal: true
            //     }
            // },
//             {
//                 path:"/mannerAndComplane",
//                 name:'mannerAndComplane',
//                 component:mannerAndComplane,
//                 meta:{ title:"服务态度&用户投诉" }
//             },
//             {
//                 path:"/serviceDesk",
//                 name:'serviceDesk',
//                 component:serviceDesk,
//                 meta:{ title:"服务台人员统计" }
//             },
//             {
//                 path:"/knowledgeOne",
//                 name:'knowledgeOne',
//                 component:knowledgeOne,
//                 meta:{ title:"知识库统计01" }
//             },
//             {
//                 path:"/knowledgeTwo",
//                 name:'knowledgeTwo',
//                 component:knowledgeTwo,
//                 meta:{ title:"知识库统计" }
//             },
//             {
//                 path:"/saleMoney",
//                 name:'saleMoney',
//                 component:saleMoney,
//                 meta:{ title:"销售额统计" }
//             },
//             {
//                 path:"/serviceLevel",
//                 name:'serviceLevel',
//                 component:serviceLevel,
//                 meta:{ title:"服务级别管理SLA统计" }
//             },
//             {
//                 path:"/eventManageBar",
//                 name:'eventManageBar',
//                 component:eventManageBar,
//                 meta:{ title:"事件管理统计" }
//             },
//             {
//                 path:"/accidentStaticPie",
//                 name:'accidentStaticPie',
//                 component:accidentStaticPie,
//                 meta:{ title:"事故统计" }
//             },
//             {
//                 path:"/configManagePie",
//                 name:'configManagePie',
//                 component:configManagePie,
//                 meta:{ title:"配置管理" }
//             },
//             {
//                 path:"/questionManageBar",
//                 name:'questionManageBar',
//                 component:questionManageBar,
//                 meta:{ title:"问题管理" }
//             },
//             {
//                 path:"/changeManageBar",
//                 name:'changeManageBar',
//                 component:changeManageBar,
//                 meta:{ title:"变更管理" }
//             },
//             {
//                 path:"/publishManageBar",
//                 name:'publishManageBar',
//                 component:publishManageBar,
//                 meta:{ title:"发布管理" }
//             },
//             {
//                 path:"/personnelEventStatis",
//                 name:'personnelEventStatis',
//                 component:personnelEventStatis,
//                 meta:{ title:"人员事件统计" }
//             },
//             {
//                 path:"/greatEventStatis",
//                 name:'greatEventStatis',
//                 component:greatEventStatis,
//                 meta:{ title:"重大事件统计" }
//             },
//             {
//                 path:"/eventCloseStatis",
//                 name:'eventCloseStatis',
//                 component:eventCloseStatis,
//                 meta:{ title:"事件关闭统计" }
//             },
//             {
//                 path:"/eventFinishedStatis",
//                 name:'eventFinishedStatis',
//                 component:eventFinishedStatis,
//                 meta:{ title:"事件完成统计" }
//             },
//             {
//                 path:"/eventOriginStatais",
//                 name:'eventOriginStatais',
//                 component:eventOriginStatais,
//                 meta:{ title:"事件来源统计" }
//             },
//             {
//                 path:"/efficientAndRespond",
//                 name:'efficientAndRespond',
//                 component:efficientAndRespond,
//                 meta:{ title:"工作效率以及响应" }
//             },
//             {
//                 path:"/changeEventStatis",
//                 name:'changeEventStatis',
//                 component:changeEventStatis,
//                 meta:{ title:"变更事件统计" }
//             },
//             {
//                 path:"/changeResultStatis",
//                 name:'changeResultStatis',
//                 component:changeResultStatis,
//                 meta:{ title:"变更结果统计" }
//             },
//             {
//                 path:"/publishEventStatis",
//                 name:'publishEventStatis',
//                 component:publishEventStatis,
//                 meta:{ title:"发布事件统计" }
//             },
//             {
//                 path:"/publishResultStatis",
//                 name:'publishResultStatis',
//                 component:publishResultStatis,
//                 meta:{ title:"发布结果统计" }
//             },
//             {
//                 path:"/CABChangeStatis",
//                 name:'CABChangeStatis',
//                 component:CABChangeStatis,
//                 meta:{ title:"CAB变更统计" }
//             },
//             {
//                 path:"/CABResultStatis",
//                 name:'CABResultStatis',
//                 component:CABResultStatis,
//                 meta:{ title:"CAB结果统计" }
//             },
//             {
//                 path:"/configChangeStatis",
//                 name:'configChangeStatis',
//                 component:configChangeStatis,
//                 meta:{ title:"配置项变更统计" }
//             },

//             //一线事件管理报表

//             {
//                 path:"/acceptEvents",
//                 name:'acceptEvents',
//                 component:acceptEvents,
//                 meta:{ title:"一线团队受理事件统计" }
//             },

//             {
//                 path:"/satisfactionRate",
//                 name:'satisfactionRate',
//                 component:satisfactionRate,
//                 meta:{ title:"客户满意度合格率" }
//             },

//             {
//                 path:"/exceedSLA",
//                 name:'exceedSLA',
//                 component:exceedSLA,
//                 meta:{ title:"超过SLA的事件统计" }
//             },

//             //事件经理报表
//             //事件转问题的数量
//             {
//                 path:"/eventToPro",
//                 name:'eventToPro',
//                 component:eventToPro,
//                 meta:{ title:"事件转问题的数量" }
//             },
//             //事件经理协助处理重大和超SLA事件
//             {
//                 path:"/bigEventManage",
//                 name:'bigEventManage',
//                 component:bigEventManage,
//                 meta:{ title:"事件经理协助处理重大和超SLA事件" }
//             },
//             //绕过服务台数和补录事件数量
//             {
//                 path:"/collectAndBypass",
//                 name:'collectAndBypass',
//                 component:collectAndBypass,
//                 meta:{ title:"绕过服务台数和补录事件数" }
//             },

//             //问题经理报表
//             //提交的问题数量

//             {
//                 path:"/commitedPro",
//                 name:'commitedPro',
//                 component:commitedPro,
//                 meta:{ title:"受理的二线支持" }  //默认展示二线提交数量，根据query传参不同改变title值
//             },
//             //问题经理经手的问题数量

//             {
//                 path:"/proManageHandler",
//                 name:'proManageHandler',
//                 component:proManageHandler,
//                 meta:{ title:"问题经理经手的问题数量" }
//             },
//             //问题转入变更的数量
//             {
//                 path:"/problemToChange",
//                 name:'problemToChange',
//                 component:problemToChange,
//                 meta:{ title:"问题转入变更的数量" }
//             },

//             //问题转变更数+问题直接关闭比例
//             {
//                 path:"/proToChaNproToClose",
//                 name:'proToChaNproToClose',
//                 component:proToChaNproToClose,
//                 meta:{ title:"问题转变更数+问题直接关闭比例" }
//             },

//             //服务台统计报表

//             {
//                 path:"/greatEventList",
//                 name:'greatEventList',
//                 component:greatEventList,
//                 meta:{ title:"重大事件统计" }
//             },
//             //事件是否及时关闭及满意度调查统计
//             {
//                 path:"/closeEvent",
//                 name:'closeEvent',
//                 component:closeEvent,
//                 meta:{ title:"事件是否及时关闭及满意度调查统计" }
//             },
//             //事件生成类型统计
//             {
//                 path:"/eventType",
//                 name:'eventType',
//                 component:eventType,
//                 meta:{ title:"事件生成类型统计" }
//             },
//             //服务台受理与直接处理完成事件统计
//             {
//                 path:"/acceptComplete",
//                 name:'acceptComplete',
//                 component:acceptComplete,
//                 meta:{ title:"服务台受理与直接处理完成事件统计" }
//             },
//             //事件（服务）完成统计
//             {
//                 path:"/eventComplete",
//                 name:'eventComplete',
//                 component:eventComplete,
//                 meta:{ title:"事件完成统计" }
//             },
//             //事件超时响应统计
//             {
//                 path:"/eventOutTime",
//                 name:'eventOutTime',
//                 component:eventOutTime,
//                 meta:{ title:"事件超时响应统计" }
//             },
//             //未分配工单数

//             {
//                 path:"/undistributedWork",
//                 name:'undistributedWork',
//                 component:undistributedWork,
//                 meta:{ title:"未分配工单数" }
//             },
//             //工作效率统计
//             {
//                 path:"/workEfficiency",
//                 name:'workEfficiency',
//                 component:workEfficiency,
//                 meta:{ title:"工作效率统计" }
//             },
//             //报表细化
//             //事件细化统计

//             {
//                 path:"/classifyStatistics",
//                 name:'classifyStatistics',
//                 component: classifyStatistics,
//                 meta:{ title:"事件分类统计" }
//             },
//             //事件关闭分类统计
//             {
//                 path:"/eventCloseClassify",
//                 name:'eventCloseClassify',
//                 component: eventCloseClassify,
//                 meta:{ title:"事件关闭分类统计" }
//             },
//             //事件关闭分类统计--按组统计
//             {
//                 path:"/eventCloseClassifyGroup",
//                 name:'eventCloseClassifyGroup',
//                 component: eventCloseClassifyGroup,
//                 meta:{ title:"事件关闭分类按组统计" }
//             },

//             //问题报表细化
//             //问题状态优先级紧急度统计
//             {
//                 path:"/problemStatus",
//                 name:'problemStatus',
//                 component: problemStatus,
//                 meta:{ title:"问题状态优先级紧急度统计" }
//             },
//             //问题状态用户统计
//             {
//                 path:"/proStatusUser",
//                 name:'proStatusUser',
//                 component: proStatusUser,
//                 meta:{ title:"问题状态用户统计" }
//             },
//             //问题状态用户按组统计
//             {
//                 path:"/proStatusUserGroup",
//                 name:'proStatusUserGroup',
//                 component: proStatusUserGroup,
//                 meta:{ title:"问题状态用户按组统计" }
//             },
//             // 事件管理
//             {
//                 path:"/eventManage",
//                 name:'eventManage',
//                 component:eventManage,
//                 meta:{
//                     title:"事件管理"
//                 }
//             },
//             {
//                 path:"/myEventManage",
//                 name:'myEventManage',
//                 component:myEventManage,
//                 meta:{
//                     title:"我提交的事件"
//                 }
//             },
//             {
//                 path:"/toMeEventManage",
//                 name:'toMeEventManage',
//                 component:toMeEventManage,
//                 meta:{
//                     title:"指派给我的事件"
//                 }
//             },
//             {
//                 path:"/toMyGroupEventManage",
//                 name:'toMyGroupEventManage',
//                 component:toMyGroupEventManage,
//                 meta:{
//                     title:"指派给我组的事件"
//                 }
//             },
//             {
//                 path:"/eventAdd",
//                 name:'eventAdd',
//                 component:eventAdd,
//                 meta:{
//                     title:"新增事件",
//                     isModal: true
//                 }
//             },
//             {
//                 path:"/eventDetail",
//                 name:'eventDetail',
//                 component:eventDetail,
//                 meta:{
//                     title:"事件详情",
//                 }
//             },
//             {
//                 path:"/ProcessingComplete",
//                 name:'ProcessingComplete',
//                 component:ProcessingComplete,
//                 meta:{
//                     title:"处理完成",
//                     isModal: true
//                 }
//             },

//             //变更管理
//             {
//                 path:"/changeManage",
//                 name:'changeManage',
//                 component:changeManage,
//                 meta:{
//                     title:"变更管理"
//                 }
//             },
//             {
//                 path:"/myChangeManage",
//                 name:'myChangeManage',
//                 component:myChangeManage,
//                 meta:{
//                     title:"我提交的变更"
//                 }
//             },
//             {
//                 path:"/toMeChangeManage",
//                 name:'toMeChangeManage',
//                 component:toMeChangeManage,
//                 meta:{
//                     title:"指派给我的变更"
//                 }
//             },
//             {
//                 path:"/toMyGroupChangeManage",
//                 name:'toMyGroupChangeManage',
//                 component:toMyGroupChangeManage,
//                 meta:{
//                     title:"指派给我组的变更"
//                 }
//             },
//             {
//                 path:"/changeAdd",
//                 name:'changeAdd',
//                 component:changeAdd,
//                 meta:{
//                     title:"新增变更",
//                     isModal: true
//                 }
//             },

//             //发布管理
//             {
//                 path:"/deployManage",
//                 name:'deployManage',
//                 component:deployManage,
//                 meta:{
//                     title:"发布管理"
//                 }
//             },
//             {
//                 path:"/deployAdd",
//                 name:'deployAdd',
//                 component:deployAdd,
//                 meta:{
//                     title:"新增发布",
//                     isModal: true
//                 }
//             },
//             {
//                 path:"/deployDetail",
//                 name:'deployDetail',
//                 component:deployDetail,
//                 meta:{
//                     title:"发布详情",
//                 }
//             },
//             {
//                 path:"/myDeployManage",
//                 name:'myDeployManage',
//                 component:myDeployManage,
//                 meta:{
//                     title:"我提交的发布"
//                 }
//             },
//             {
//                 path:"/toMeDeployManage",
//                 name:'toMeDeployManage',
//                 component:toMeDeployManage,
//                 meta:{
//                     title:"指派给我的发布"
//                 }
//             },
//             {
//                 path:"/toMyGroupDeployManage",
//                 name:'toMyGroupDeployManage',
//                 component:toMyGroupDeployManage,
//                 meta:{
//                     title:"指派给我组的发布"
//                 }
//             },
//             {
//                 path:"/changeDetail",
//                 name:'changeDetail',
//                 component:changeDetail,
//                 meta:{
//                     title:"变更详情",
//                 }
//             },


//             // 通用页面
//             {
//                 path:"/requesterList",
//                 name:'requesterList',
//                 component:requesterList,
//                 meta:{
//                     title:"请选择请求人",
//                     isModal: true,
//                 }
//             },
//             {
//                 path:"/flowChart",
//                 name:'flowChart',
//                 component:flowChart,
//                 meta:{
//                     title:"流程跟踪",
//                     isModal: true,
//                 }
//             },
//             {
//                 path:"/applicantList",
//                 name:'applicantList',
//                 component:applicantList,
//                 meta:{
//                     title:"请选择申请人",
//                     isModal: true,
//                 }
//             },
//             {
//                 path:"/appointUser",
//                 name:'appointUser',
//                 component:appointUser,
//                 meta:{
//                     title:"请选择组员",
//                     isModal: true,
//                 }
//             },
//             {
//                 path:"/reporterList",
//                 name:'reporterList',
//                 component:reporterList,
//                 meta:{
//                     title:"请选择报告人",
//                     isModal: true,
//                 }
//             },
//             {
//                 path:"/relevancyEvent",
//                 name:'relevancyEvent',
//                 component:relevancyEvent,
//                 meta:{
//                     title:"关联事件",
//                     isModal: true,
//                 }
//             },
//             {
//                 path:"/relevancyConfig",
//                 name:'relevancyConfig',
//                 component:relevancyConfig,
//                 meta:{
//                     title:"关联配置项",
//                     isModal: true,
//                 }
//             },

//             {
//                 path:"/relevancyApp",
//                 name:'relevancyApp',
//                 component:relevancyApp,
//                 meta:{
//                     title:"关联应用",
//                     isModal: true,
//                 }
//             },
//             {
//                 path:"/relevancySla",
//                 name:'relevancySla',
//                 component:relevancySla,
//                 meta:{
//                     title:"关联SLA",
//                     isModal: true,
//                     modalWidth: '640px'
//                 }
//             },
//             {
//                 path:"/relevancyService",
//                 name:'relevancyService',
//                 component:relevancyService,
//                 meta:{
//                     title:"关联服务",
//                     isModal: true,
//                 }
//             },
//             {
//                 path:"/relevancyChange",
//                 name:'relevancyChange',
//                 component:relevancyChange,
//                 meta:{
//                     title:"关联变更",
//                     isModal: true,
//                 }
//             },
//             {
//                 path:"/relevancyDeploy",
//                 name:'relevancyDeploy',
//                 component:relevancyDeploy,
//                 meta:{
//                     title:"关联发布",
//                     isModal: true,
//                 }
//             },
//             {
//                 path:"/relevancyProblem",
//                 name:'relevancyProblem',
//                 component:relevancyProblem,
//                 meta:{
//                     title:"关联问题",
//                     isModal: true,
//                 }
//             },
//             {
//                 path:"/relevancyFault",
//                 name:'relevancyFault',
//                 component:relevancyFault,
//                 meta:{
//                     title:"关联故障",
//                     isModal: true,
//                 }
//             },
//             {
//                 path:"/appoint",
//                 name:'appoint',
//                 component:appoint,
//                 meta:{
//                     title:"指派",
//                     isModal: true,
//                 }
//             },
//             {
//                 path:"/changeAppoint",
//                 name:'changeAppoint',
//                 component:changeAppoint,
//                 meta:{
//                     title:"变更流程操作",
//                     isModal: true,
//                 }
//             },
//             {
//                 path:"/deployAppoint",
//                 name:'deployAppoint',
//                 component:deployAppoint,
//                 meta:{
//                     title:"发布流程操作",
//                     isModal: true,
//                 }
//             },
//             {
//                 path:"/busyness",
//                 name:'busyness',
//                 component:busyness,
//                 meta:{
//                     title:"繁忙度统计",
//                     isModal: true,
//                 }
//             },
//             {
//                 path:"/redirect",
//                 name:'redirect',
//                 component:redirect,

//             },

//             {
//                 path:"/department",
//                 name:'department',
//                 component:department,
//                 meta:{
//                     title:"组织机构列表",
//                     isModal: true,
//                 }
//             },
//             {
//                 path:"/clientVisit",
//                 name:'clientVisit',
//                 component:clientVisit,
//                 meta:{
//                     title:"客户回访",
//                     isModal: true,
//                 }
//             },
//             {
//                 path:"/handleComment",
//                 name:'handleComment',
//                 component:handleComment,
//                 meta:{
//                     title:"回访完成",
//                     isModal: true,
//                 }
//             },
//             {
//                 path:"/setHour",
//                 name:'setHour',
//                 component:setHour,
//                 meta:{
//                     title:"设置工时",
//                     isModal: true,
//                 }
//             },

//             // 问题管理
//             {
//                 path:"/problemManage",
//                 name:'problemManage',
//                 component:problemManage,
//                 meta:{
//                     title:"问题管理"
//                 }
//             },
//             {
//                 path:"/myProblemManage",
//                 name:'myProblemManage',
//                 component:myProblemManage,
//                 meta:{
//                     title:"我提交的问题"
//                 }
//             },
//             {
//                 path:"/toMeProblem",
//                 name:'toMeProblem',
//                 component:toMeProblem,
//                 meta:{
//                     title:"指派给我的问题"
//                 }
//             },
//             {
//                 path:"/toMyGroupProblem",
//                 name:'toMyGroupProblem',
//                 component:toMyGroupProblem,
//                 meta:{
//                     title:"指派给我组的问题"
//                 }
//             },
//             {
//                 path:"/problemAdd",
//                 name:'problemAdd',
//                 component:problemAdd,
//                 meta:{
//                     title:"新增问题",
//                     isModal: true
//                 }
//             },
//             {
//                 path:"/problemDetail",
//                 name:'problemDetail',
//                 component:problemDetail,
//                 meta:{
//                     title:"问题详情",
//                 }
//             },
//             {
//                 path:"/proAssessComplete",
//                 name:'proAssessComplete',
//                 component:proAssessComplete,
//                 meta:{
//                     title:"分析评估",
//                     isModal: true
//                 }
//             },
//             {
//                 path:"/proInquiryComplete",
//                 name:'proInquiryComplete',
//                 component:proInquiryComplete,
//                 meta:{
//                     title:"制定解决方案",
//                     isModal: true
//                 }
//             },
//             {
//                 path:"/proRemark",
//                 name:'proRemark',
//                 component:proRemark,
//                 meta:{
//                     title:"处理完成",
//                     isModal: true
//                 }
//             },
//             //投诉管理

//             {
//                 path:"/myComplaints",
//                 name:'myComplaints',
//                 component:myComplaints,
//                 meta:{
//                     title:"我的投诉"
//                 }
//             },
//             {
//                 path:"/allComplaints",
//                 name:'allComplaints',
//                 component:allComplaints,
//                 meta:{
//                     title:"全部投诉"
//                 }
//             },
//             {
//                 path:"/addMyComplaints",
//                 name:'addMyComplaints',
//                 component:addMyComplaints,
//                 meta:{
//                     title:"我要投诉",
//                     isModal:true
//                 }
//             },
//             // 分类管理
//             {
//                 path:"/classifyKnowledge",
//                 name:'classifyKnowledge',
//                 component:classifyKnowledge,
//                 meta:{
//                     title:"分类知识"
//                 }
//             },
//             {
//                 path:"/changeKnowledgeMes",
//                 name:'changeKnowledgeMes',
//                 component:changeKnowledgeMes,
//                 meta:{
//                     title:"新增",
//                     isModal: true
//                 }
//             },
//             {
//                 path:"/classifyQuestion",
//                 name:'classifyQuestion',
//                 component:classifyQuestion,
//                 meta:{
//                     title:"分类问题"
//                 }
//             },
//             {
//                 path:"/changeQuestionMes",
//                 name:'changeQuestionMes',
//                 component:changeQuestionMes,
//                 meta:{
//                     title:"新增",
//                     isModal: true
//                 }
//             },
//             {
//                 path:"/classifyRequest",
//                 name:'classifyRequest',
//                 component:classifyRequest,
//                 meta:{
//                     title:"事件分类"
//                 }
//             },
//             {
//                 path:"/changeRequestMes",
//                 name:'changeRequestMes',
//                 component:changeRequestMes,
//                 meta:{
//                     title:"新增",
//                     isModal: true
//                 }
//             },
//             {
//                 path:"/classifyConfigurate",
//                 name:'classifyConfigurate',
//                 component:classifyConfigurate,
//                 meta:{
//                     title:"配置项分类"
//                 }
//             },
//             {
//                 path:"/changeConfigurateMes",
//                 name:'changeConfigurateMes',
//                 component:changeConfigurateMes,
//                 meta:{
//                     title:"新增",
//                     isModal: true
//                 }
//             },
//             {
//                 path:"/classifyPublish",
//                 name:'classifyPublish',
//                 component:classifyPublish,
//                 meta:{
//                     title:"发布分类"
//                 }
//             },
//             {
//                 path:"/changePublishMes",
//                 name:'changePublishMes',
//                 component:changePublishMes,
//                 meta:{
//                     title:"新增",
//                     isModal: true
//                 }
//             },
//             {
//                 path:"/classifyChange",
//                 name:'classifyChange',
//                 component:classifyChange,
//                 meta:{
//                     title:"变更分类"
//                 }
//             },
//             {
//                 path:"/changeChangeMes",
//                 name:'changeChangeMes',
//                 component:changeChangeMes,
//                 meta:{
//                     title:"新增",
//                     isModal: true
//                 }
//             },


//             // 文档管理
//             {
//                 path:"/documentList",
//                 name:'documentList',
//                 component:documentList,
//                 meta:{
//                     title:"文档列表"
//                 }
//             },
//             {
//                 path:"/changeListMes",
//                 name:'changeListMes',
//                 component:changeListMes,
//                 meta:{
//                     title:"新增",
//                     isModal: true
//                 }
//             },
//             {
//                 path:"/documentDirectory",
//                 name:'documentDirectory',
//                 component:documentDirectory,
//                 meta:{
//                     title:"文档目录"
//                 }
//             },
//             {
//                 path:"/changeDirMes",
//                 name:'changeDirMes',
//                 component:changeDirMes,
//                 meta:{
//                     title:"新增",
//                     isModal: true
//                 }
//             },
//             {
//                 path:"/documentDetail",
//                 name:'documentDetail',
//                 component:documentDetail,
//                 meta:{
//                     title:"详情",
//                     isModal: true
//                 }
//             },

//             // 知识库
//             {
//                 path:"/knowledgeList",
//                 name:'knowledgeList',
//                 component:knowledgeList,
//                 meta:{
//                     title:"知识列表"
//                 }
//             },
//             {
//                 path:"/searchKnowledge",
//                 name:'searchKnowledge',
//                 component:searchKnowledge,
//                 meta:{
//                     title:"知识搜索"
//                 }
//             },
//             {
//                 path:"/historyKnowledge",
//                 name:'historyKnowledge',
//                 component:historyKnowledge,
//                 meta:{
//                     title:"历史版本"
//                 }
//             },
//             {
//                 path:"/knowledgeDetail",
//                 name:'knowledgeDetail',
//                 component:knowledgeDetail,
//                 meta:{
//                     title:"知识详情",
//                 }
//             },
//             {
//                 path:"/addKnowledge",
//                 name:'addKnowledge',
//                 component:addKnowledge,
//                 meta:{
//                     title:"增加",
//                     isModal:true,
//                 }
//             },
//             {
//                 path:"/changeStatus",
//                 name:'changeStatus',
//                 component:changeStatus,
//                 meta:{
//                     title:"审批",
//                     isModal:true,
//                 }
//             },

//             // 配置项管理
//             {
//                 path: '/configurationList',
//                 name: 'ConfigurationList',
//                 component: ConfigurationList,
//                 meta: { title: '配置项列表' }
//             },
//             {
//                 path: '/configurationUpdata',
//                 name: 'UpdataConfiguration',
//                 component: UpdataConfiguration,
//                 meta: { title: '新增配置项', isModal: true }
//             },
//             {
//                 path: '/configurationMy',
//                 name: 'MyConfiguration',
//                 component: MyConfiguration,
//                 meta: { title: '我的配置项' }
//             },
//             {
//                 path: '/configurationDetail',
//                 name: 'ConfigurationDetail',
//                 component: ConfigurationDetail,
//                 meta: {
//                     title: '配置项详情',
//                 },
//             },
//             {
//                 path: '/eventUpdata',
//                 name: 'EventUptata',
//                 component: EventUptata,
//                 meta: {
//                     title: '新增配置项关系',
//                     isModal: true
//                 },
//             },
//             {
//                 path: '/requeryUserList',
//                 name: 'RequeryUserList',
//                 component: RequeryUserList,
//                 meta: { title: '选择人员', isModal: true },
//             },

//             // 服务管理
//             {
//                 path: '/serveCatalog',
//                 name: 'ServeCatalog',
//                 component: ServeCatalog,
//                 meta: { title: '服务目录' }
//             },
//             {
//                 path: '/serveCatalogUpdata',
//                 name: 'ServeCatalogUpdata',
//                 component: ServeCatalogUpdata,
//                 meta: { title: '新增服务', isModal: true }
//             },
//             {
//                 path: '/serveBargain',
//                 name: 'ClientBargain',
//                 component: ClientBargain,
//                 meta: { title: '合同目录' }
//             },
//             {
//                 path: '/serveBargainUpdata',
//                 name: 'ClientBargainUpdata',
//                 component: ClientBargainUpdata,
//                 meta: { title: '新增客户合同', isModal: true }
//             },
//             {
//                 path: '/serveBargainDetail',
//                 name: 'ClientBargainDetail',
//                 component: ClientBargainDetail,
//                 meta: { title: '客户合同详情', isModal: true }
//             },
//             {
//                 path: '/serveCelevel',
//                 name: 'serviCelevel',
//                 component: serviCelevel,
//                 meta: { title: '服务水平协议' }
//             },
//             {
//                 path: '/serveCelevelUpdata',
//                 name: 'serviCelevelUpdata',
//                 component: serviCelevelUpdata,
//                 meta: { title: '新增服务水平协议', isModal: true }
//             },
//             {
//                 path: '/serveCelevelDetail',
//                 name: 'serviCelevelDetail',
//                 component: serviCelevelDetail,
//                 meta: { title: '服务水平协议详情', isModal: true }
//             },
//             {
//                 path: '/serveTeam',
//                 name: 'ServeTeam',
//                 component: ServeTeam,
//                 meta: { title: '服务团队' }
//             },
//             {
//                 path: '/serveUser',
//                 name: 'ServeUser',
//                 component: ServeUser,
//                 meta: { title: '团队人员', isModal: true }
//             },
//             {
//                 path: '/systemPerson',
//                 name: 'systemPerson',
//                 component: systemPerson,
//                 meta: { title: '人员组织关系' }
//             },
//             {
//                 path: '/systemPersonUpdata',
//                 name: 'systemPersonUpdata',
//                 component: systemPersonUpdata,
//                 meta: { title: '添加人员组织关系', isModal: true }
//             },
//             {
//                 path: '/systemUser',
//                 name: 'systemUser',
//                 component: systemUser,
//                 meta: { title: '人员' }
//             },
//             {
//                 path: '/systemUserAdd',
//                 name: 'systemUserAdd',
//                 component: systemUserAdd,
//                 meta: { title: '添加人员', isModal: true }
//             },
//             {
//                 path: '/topologicalGraph',
//                 name: 'topologicalGraph',
//                 component: topologicalGraph,
//                 meta: {
//                     title: '配置项拓扑图',
//                     isModal: true
//                 }


//             },

//             {
//                 path: '/showPologicalDetail',
//                 name: 'showPologicalDetail',
//                 component: showPologicalDetail,
//                 meta: {
//                     title: '配置项详情',
//                     isModal: true
//                 }
//             },


//             {
//                 path: '/showAppDetail',
//                 name: 'showAppDetail',
//                 component: showAppDetail,
//                 meta: {
//                     title: '应用详情',
//                     isModal: true
//                 }
//             },
//             //巡检管理
//             {
//                 path:"/inspectionManage",
//                 name:'inspectionManage',
//                 component:inspectionManage,
//                 meta:{
//                     title:"巡检管理"
//                 }
//             },
//             {
//                 path:"/inspectionCalendar",
//                 name:'inspectionCalendar',
//                 component:inspectionCalendar,
//                 meta:{
//                     title:"巡检计划月历"
//                 }
//             },
//             {
//                 path:"/inspectionRecord",
//                 name:'inspectionRecord',
//                 component:inspectionRecord,
//                 meta:{
//                     title:"巡检记录"
//                 }
//             },
//             {
//                 path:"/inspectionAdd",
//                 name:'inspectionAdd',
//                 component:inspectionAdd,
//                 meta:{
//                     title:"巡检新增",
//                     isModal:true
//                 }
//             },
//             {
//                 path:"/inspectionAgency",
//                 name:'inspectionAgency',
//                 component:inspectionAgency,
//                 meta:{
//                     title:"巡检待办",

//                 }
//             },
//             {
//                 path:"/inspectionTable",
//                 name:'inspectionTable',
//                 component:inspectionTable,
//                 meta:{
//                     title:"巡检表单",
//                     isModal:true
//                 }
//             },
//             {
//                 path:"/addConfiguration",
//                 name:'addConfiguration',
//                 component:addConfiguration,
//                 meta:{
//                     title:"选择配置项",
//                     isModal:true
//                 }
//             },




//             //排班管理
//             {
//                 path:"/flightManagement",
//                 name:'flightManagement',
//                 component:flightManagement,
//                 meta:{
//                     title:"班次管理"
//                 }
//             },

//             {
//                 path:"/schedulingCalendar",
//                 name:'schedulingCalendar',
//                 component:schedulingCalendar,
//                 meta:{
//                     title:"排班日历"
//                 }
//             },
//             {
//                 path:"/schedulingList",
//                 name:'schedulingList',
//                 component:schedulingList,
//                 meta:{
//                     title:"排班列表"
//                 }
//             },
//             {
//                 path:"/addScheduling",
//                 name:'addScheduling',
//                 component:addScheduling,
//                 meta:{
//                     title:"新增班次",
//                     isModal: true
//                 }
//             },
//             {
//                 path:"/changeScheduling",
//                 name:'changeScheduling',
//                 component:changeScheduling,
//                 meta:{
//                     title:"调班",
//                     isModal: true
//                 }
//             },
//             {
//                 path:"/addSchedulingList",
//                 name:'addSchedulingList',
//                 component:addSchedulingList,
//                 meta:{
//                     title:"新增排班",
//                     isModal: true
//                 }
//             },

//             // 系统管理
//             {
//                 path:"/userManagement",
//                 name:'userManagement',
//                 component:userManagement,
//                 meta:{
//                     title:"权限用户管理"
//                 }
//             },
//             {
//                 path:"/userAdd",
//                 name:'userAdd',
//                 component:userAdd,
//                 meta:{
//                     title:"创建用户",
//                     isModal: true,
//                 }
//             },
//             {
//                 path:"/roleManagement",
//                 name:'roleManagement',
//                 component:roleManagement,
//                 meta:{
//                     title:"角色管理"
//                 }
//             },
//             {
//                 path:"/roleAdd",
//                 name:'roleAdd',
//                 component:roleAdd,
//                 meta:{
//                     title:"创建角色",
//                     isModal: true
//                 }
//             },
//             {
//                 path:"/iconManage",
//                 name:'iconManage',
//                 component:iconManage,
//                 meta:{
//                     title:"图标管理"
//                 }
//             },

//             {
//                 path:"/iconAdd",
//                 name:'iconAdd',
//                 component:iconAdd,
//                 meta:{
//                     title:"新增图标",
//                     isModal: true
//                 }
//             },
//             {
//                 path:"/thirdPartyUserList",
//                 name:'thirdPartyUserList',
//                 component:thirdPartyUserList,
//                 meta:{
//                     title:"第三方用户"
//                 }
//             },
//             {
//                 path:"/thirdPartyUserAdd",
//                 name:'thirdPartyUserAdd',
//                 component:thirdPartyUserAdd,
//                 meta:{
//                     title:"第三方用户新增",
//                     isModal:true
//                 }
//             },

//             {
//                 path:"/onlineUsersList",
//                 name:'onlineUsersList',
//                 component:onlineUsersList,
//                 meta:{
//                     title:"在线用户"
//                 }
//             },
//             {
//                 path:"/onlineUsersView",
//                 name:'onlineUsersView',
//                 component:onlineUsersView,
//                 meta:{
//                     title:"个人信息",
//                     isModal:true
//                 }
//             },


//             // 应用管理
//             {
//                 path: '/AppcenterManage',
//                 name: 'AppcenterManage',
//                 component: AppcenterManage,
//                 meta: { title: '应用列表' }
//             },
//             {
//                 path: '/myAppcenterManage',
//                 name: 'myAppcenterManage',
//                 component: myAppcenterManage,
//                 meta: { title: '我的应用' }
//             },
//             {
//                 path: '/auditApp',
//                 name: 'AuditApp',
//                 component: AuditApp,
//                 meta: { title: '是否通过该应用', isModal: true }
//             },

//             {
//                 path: '/unLoad',
//                 name: 'unLoad',
//                 component: unLoad,
//                 meta: { title: '上传图片', isModal: true }
//             },


//             // 服务器管理
//             {
//                 path: '/ServerManage',
//                 name: 'ServerManage',
//                 component: ServerManage,
//                 meta: { title: '服务器列表' }
//             },
//             {
//                 path: '/serverAdd',
//                 name: 'serverAdd',
//                 component: serverAdd,
//                 meta: { title: '新增服务器',isModal:true }
//             },

//             // 数据字典
//             {
//                 path: '/dictionaryMessage',
//                 name: 'DictionaryMessage',
//                 component: DictionaryMessage,
//                 meta: { title: '数据字典列表' }
//             },
//             {
//                 path: '/dictionaryAdd',
//                 name: 'DictionaryAdd',
//                 component: DictionaryAdd,
//                 meta: { title: '新增数据字典', isModal: true }
//             },

//             // 持续集成
//             {
//                 path: '/appcenterTree',
//                 name: 'Tree',
//                 component: Tree,
//                 meta: { title: '应用树' },
//                 children: [{
//                     path: '/appcenterTree/useDetail',
//                     name: 'UseDetail',
//                     component: UseDetail,
//                     meta: { title: '应用概述' },
//                 },
//                     {
//                         path: '/appcenterTree/menuDetail',
//                         name: 'MenuDetail',
//                         component: MenuDetail,
//                         meta: { title: '目录详情' },
//                     },
//                     {
//                         path: '/appcenterTree/serverList',
//                         name: 'ServerList',
//                         component: ServerList,
//                         meta: { title: '服务器' },
//                     },
//                     {
//                         path: '/appcenterTree/integration',
//                         name: 'Integration',
//                         component: Integration,
//                         meta: { title: '持续集成' },
//                         children: [{
//                             path: '/appcenterTree/integration/integrationHome',
//                             name: 'IntegrationHome',
//                             component: IntegrationHome,
//                             meta: { title: '构建历史' },
//                         },
//                             {
//                                 path: '/appcenterTree/integration/buildDetail',
//                                 name: 'BuildDetail',
//                                 component: BuildDetail,
//                                 meta: { title: '构建详情' },
//                             },
//                             {
//                                 path: '/appcenterTree/integration/buildLog',
//                                 name: 'BuildLog',
//                                 component: BuildLog,
//                                 meta: { title: '构建日志' },
//                             },
//                             {
//                                 path: '/appcenterTree/integration/paramsBuild',
//                                 name: 'ParamsBuild',
//                                 component: ParamsBuild,
//                                 meta: { title: '构建参数' },
//                             },
//                             {
//                                 path: '/appcenterTree/integration/prevBuild',
//                                 name: 'PrevBuild',
//                                 component: PrevBuild,
//                                 meta: { title: '上一次构建' },
//                             },
//                             {
//                                 path: '/appcenterTree/integration/rollBack',
//                                 name: 'RollBack',
//                                 component: RollBack,
//                                 meta: { title: '回滚', isModal: true },
//                             },
//                         ]
//                     }
//                 ]
//             },
//             {
//                 path: '/appcenterUseAdd',
//                 name: 'UseAdd',
//                 component: UseAdd,
//                 meta: { title: '新增应用', isModal: true },

//             },
//             {
//                 path: '/appcenterMenuAdd',
//                 name: 'MenuAdd',
//                 component: MenuAdd,
//                 meta: { title: '新增目录', isModal: true },

//             },
//             {
//                 path: '/paramsAdd',
//                 name: 'ParamsAdd',
//                 component: ParamsAdd,
//                 meta: { title: '新增参数', isModal: true },

//             },
//             {
//                 path: '/paramsMessage',
//                 name: 'ParamsMessage',
//                 component: ParamsMessage,
//                 meta: { title: '部署信息', isModal: true,modalWidth: '1300px' },

//             },
//             // {
//             //     path: '/deployAll',
//             //     name: 'DeployAll',
//             //     component: DeployAll,
//             //     meta: { title: '发布历史' }
//             // },
//             // {
//             //     path: '/deployMy',
//             //     name: 'DeployMy',
//             //     component: DeployMy,
//             //     meta: { title: '我的发布' }
//             // },
//             // {
//             //     path: '/myApproval',
//             //     name: 'MyApproval',
//             //     component: MyApproval,
//             //     meta: { title: '我的审批' }
//             // },
//             // {
//             //     path: '/approval',
//             //     name: 'Approval',
//             //     component: Approval,
//             //     meta: { title: '执行审批', isModal: true }
//             // },
//             {
//                 path: '/deployNew',
//                 name: 'DeployNew',
//                 component: DeployNew,
//                 meta: { title: '新建部署单', isModal: true }
//             },
//             {
//                 path: '/deployLine',
//                 name: 'DeployLine',
//                 component: DeployLine,
//                 meta: { title: '部署上线' }
//             },
//             //变更细化
//             {
//                 path: '/changeStatusList',
//                 name: 'changeStatusList',
//                 component: changeStatusList,
//                 meta: { title: '变更RFC状态实时汇总' }
//             },
//             {
//                 path: '/changeStatusStatis',
//                 name: 'changeStatusStatis',
//                 component: changeStatusStatis,
//                 meta: { title: '变更状态统计' }
//             },
//             {
//                 path: '/groupeChangeStatus',
//                 name: 'groupeChangeStatus',
//                 component: groupeChangeStatus,
//                 meta: { title: '组别变更状态统计' }
//             },
//             {
//                 path: '/changeRFCNum',
//                 name: 'changeRFCNum',
//                 component: changeRFCNum,
//                 meta: { title: '变更RFC数量' }
//             },
//             {
//                 path: '/changeRFCNumStatus',
//                 name: 'changeRFCNumStatus',
//                 component: changeRFCNumStatus,
//                 meta: { title: '变更RFC数量状态统计' }
//             },
//             {
//                 path: '/changeRFCNumGroupe',
//                 name: 'changeRFCNumGroupe',
//                 component: changeRFCNumGroupe,
//                 meta: { title: '变更RFC数量组别状态统计' }
//             },
//             {
//                 path: '/changeRFCCloseNum',
//                 name: 'changeRFCCloseNum',
//                 component: changeRFCCloseNum,
//                 meta: { title: '变更RFC的关闭数量' }
//             },
//             {
//                 path: '/changeRFCCloseNumStatus',
//                 name: 'changeRFCCloseNumStatus',
//                 component: changeRFCCloseNumStatus,
//                 meta: { title: '变更RFC关闭数量状态统计' }
//             },
//             {
//                 path: '/changeRFCCloseNumGroupe',
//                 name: 'changeRFCCloseNumGroupe',
//                 component: changeRFCCloseNumGroupe,
//                 meta: { title: '变更RFC关闭数量组别统计' }
//             },
//             //发布细化
//             {
//                 path: '/publishStatusList',
//                 name: 'publishStatusList',
//                 component: publishStatusList,
//                 meta: { title: '发布RFC状态实时汇总' }
//             },
//             {
//                 path: '/publishStatusStatis',
//                 name: 'publishStatusStatis',
//                 component: publishStatusStatis,
//                 meta: { title: '发布状态统计' }
//             },
//             {
//                 path: '/groupePublishStatus',
//                 name: 'groupePublishStatus',
//                 component: groupePublishStatus,
//                 meta: { title: '组别发布状态统计' }
//             },
//             {
//                 path: '/publishRFCNum',
//                 name: 'publishRFCNum',
//                 component: publishRFCNum,
//                 meta: { title: '发布RFC数量' }
//             },
//             {
//                 path: '/publishRFCNumStatus',
//                 name: 'publishRFCNumStatus',
//                 component: publishRFCNumStatus,
//                 meta: { title: '发布RFC数量状态统计' }
//             },
//             {
//                 path: '/publishRFCNumGroupe',
//                 name: 'publishRFCNumGroupe',
//                 component: publishRFCNumGroupe,
//                 meta: { title: '发布RFC数量组别状态统计' }
//             },
//             {
//                 path: '/publishRFCCloseNum',
//                 name: 'publishRFCCloseNum',
//                 component: publishRFCCloseNum,
//                 meta: { title: '发布RFC的关闭数量' }
//             },
//             {
//                 path: '/publishRFCCloseNumStatus',
//                 name: 'publishRFCCloseNumStatus',
//                 component: publishRFCCloseNumStatus,
//                 meta: { title: '发布RFC关闭数量状态统计' }
//             },
//             {
//                 path: '/publishRFCCloseNumGroupe',
//                 name: 'publishRFCCloseNumGroupe',
//                 component: publishRFCCloseNumGroupe,
//                 meta: { title: '发布RFC关闭数量组别统计' }
//             },

//         ]
//     },
//     {path: '*', redirect: '/'}
// ];
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const constantRouterMap=[]
export default new Router({
    routes:constantRouterMap
})